import { uniqArray as A } from "@hprofits/utils/arrays";
import { UserIdSchema as h } from "../schemas.js";
import { UserRoleSchema as n, PrivilegeSchema as e } from "./schemas.js";
const m = 3, a = 4, t = 5, i = 9, s = 10, c = 11, x = (r) => {
  switch (r) {
    case m:
      return n.enum.Publisher;
    case a:
      return n.enum.Advert;
    case t:
      return n.enum.Admin;
    case i:
      return n.enum.AdAdmin;
    case s:
      return n.enum.Exchange;
    case c:
      return n.enum.Manager;
  }
  throw new Error(`Unknown role id: ${r}`);
}, P = (r) => {
  switch (r) {
    case n.enum.Publisher:
      return m;
    case n.enum.Advert:
      return a;
    case n.enum.Admin:
      return t;
    case n.enum.AdAdmin:
      return i;
    case n.enum.Exchange:
      return s;
    case n.enum.Manager:
      return c;
    default: {
      const u = r;
      throw new Error(`Unknown role: ${u}`);
    }
  }
}, l = (r) => A(r.flatMap(g)), g = (r) => {
  switch (r) {
    case n.enum.Admin:
      return [
        e.enum.SuperAdmin,
        e.enum.ReadAdmin,
        e.enum.WriteAdmin,
        e.enum.ReadAdvert,
        e.enum.WriteAdvert,
        e.enum.ReadPublisher,
        e.enum.WritePublisher,
        e.enum.ReadExchange,
        e.enum.WriteExchange,
        e.enum.SplitTrafficSourceBySsp,
        e.enum.ManageUsers,
        e.enum.AssignAdminRole,
        e.enum.ManageAdExchangeBindings
      ];
    case n.enum.AdAdmin:
      return [
        e.enum.ReadAdmin,
        e.enum.WriteAdmin,
        e.enum.ReadAdvert,
        e.enum.WriteAdvert,
        e.enum.ReadPublisher,
        e.enum.WritePublisher,
        e.enum.ReadExchange,
        e.enum.WriteExchange,
        e.enum.SplitTrafficSourceBySsp,
        e.enum.ManageUsers,
        e.enum.AssignAdminRole,
        e.enum.ManageAdExchangeBindings
      ];
    case n.enum.Manager:
      return [
        e.enum.ReadAdmin,
        e.enum.WriteAdmin,
        e.enum.ReadAdvert,
        e.enum.WriteAdvert,
        e.enum.ReadPublisher,
        e.enum.WritePublisher,
        e.enum.ReadExchange,
        e.enum.WriteExchange,
        e.enum.SplitTrafficSourceBySsp,
        e.enum.ManageUsers
      ];
    case n.enum.Advert:
      return [e.enum.ReadAdvert, e.enum.WriteAdvert, e.enum.ManageOwnBilling];
    case n.enum.Publisher:
      return [
        e.enum.ReadPublisher,
        e.enum.WritePublisher,
        e.enum.ManageOwnBilling
      ];
    case n.enum.Exchange:
      return [e.enum.ReadExchange, e.enum.WriteExchange];
    default: {
      const u = r;
      throw new Error(`Unknown role: ${u}`);
    }
  }
}, _ = (r, u, d, o) => ({
  id: h.parse(r.userId),
  username: u,
  title: d,
  privileges: l(r.roles),
  refreshToken: o
});
export {
  _ as jwtToAuthUser,
  g as mapPrivilegesForRole,
  l as mapPrivilegesForRoles,
  x as resolveRoleById,
  P as resolveRoleId
};
//# sourceMappingURL=utils.js.map
